// src/components/ArchiveItem/index.jsx
import React from 'react';
import { Card, Tag, Button, Divider } from 'antd';
import { CalendarOutlined, TagOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const ArchiveItem = ({ post, year, month, onViewDetails }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('zh-CN', { 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getSeasonIcon = (month) => {
    const seasonMap = {
      1: '❄️', 2: '❄️', 3: '🌸', 4: '🌸', 5: '🌸', 6: '🌞',
      7: '🌞', 8: '🌞', 9: '🍂', 10: '🍂', 11: '🍂', 12: '❄️'
    };
    return seasonMap[month] || '📜';
  };

  return (
    <Card 
      className="archive-item-card"
      styles={{
        body: { padding: '20px' }
      }}
    >
      <div className="archive-item-header">
        <div className="timeline-marker">
          <div className="marker-year">{year}</div>
          <div className="marker-month">
            {getSeasonIcon(month)}{month}月
          </div>
          <div className="marker-line"></div>
        </div>
        
        <div className="item-content">
          <div className="item-date">
            <CalendarOutlined />
            <span className="date-text">{formatDate(post.date)}</span>
          </div>
          
          <Link to={`/post/${post.id}`} className="item-title-link">
            <h3 className="item-title">{post.title}</h3>
          </Link>
          
          <p className="item-summary">{post.summary}</p>
          
          <div className="item-tags">
            <TagOutlined style={{ marginRight: 8, color: '#8b4513' }} />
            {post.tags.map((tag, index) => (
              <Tag key={index} className="antique-tag">
                {tag}
              </Tag>
            ))}
          </div>
          
          <Divider className="item-divider" />
          
          <div className="item-footer">
            <div className="author-info">
              <span className="author-avatar">🕵️</span>
              <span className="author-name">{post.author}</span>
            </div>
            
            <div className="item-actions">
              <Link to={`/post/${post.id}`}>
                <Button 
                  type="link" 
                  icon={<EyeOutlined />}
                  className="view-btn"
                >
                  阅读全文
                </Button>
              </Link>
              <Button 
                type="text" 
                onClick={() => onViewDetails && onViewDetails(post)}
                className="details-btn"
              >
                详情
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      {/* 文物类别标识 */}
      <div className="cultural-badge">
        {post.tags[0] || '文物'}
      </div>
    </Card>
  );
};

export default ArchiveItem;